<template>
  <a-locale-provider :locale="locale">
    <div class="order-search-container">
      <div class="order-search-tab">
        <a-tabs
          defaultActiveKey="0"
          v-model="activeTabKey"
        >
          <!--精准查询-->
          <a-tab-pane tab="特殊退票" key="1">
            <a-alert
              message="特殊退票仅支持查询"
              type="warning"
              show-icon
              :closable="false">
            </a-alert>
            <a-form class="order-search-form" :form="fullForm" :layout="formLayout">
              <a-row>
                <a-col :xs="12">
                  <a-form-item
                    label="申请时间"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="startCreateTime"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="endCreateTime"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xs="12">
                  <a-form-item
                    label="航班日期"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="startDepTime"
                      :disabledDate="startSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="endDepTime"
                      :disabledDate="endSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="12">
                  <a-form-item
                    label="航段"
                  >
                    <l8-flightcityselector
                      v-model="depCode"
                      placeholder="出发城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <l8-flightcityselector
                      v-model="arrCode"
                      placeholder="到达城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                </a-col>
                <a-col :xs="12">
                  <a-form-item
                    label="退票类型"
                  >
                    <a-select v-model="refundType" defaultValue="" class="refund-type-select">
                      <a-select-option v-for="item in refundTypeDictData" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="8">
                  <a-form-item
                    label="退单状态"
                  >
                    <a-select v-model="status" defaultValue="">
                      <a-select-option v-for="item in statusDictData" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xs="8">
                  <a-form-item v-if="userType === 'AGENT'"
                          label="OfficeNo"
                  >
                    <a-input v-model="officeNo"></a-input>
                  </a-form-item>
                  <a-form-item>
                    <a-button
                      class="order-primary-btn"
                      type="primary"
                      :loading="orderLoading"
                      @click="fullFormSubmitHandler"
                    >
                      查询
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="order-search-table">
        <a-table class="order-table"
                 :dataSource='orderListData'
                 :columns='orderListCols'
                 :pagination="orderPagination"
                 :loading="orderLoading"
                 @change="orderListChangeHandler"
        >
          <div slot="spRefundSegments" slot-scope="spRefundSegments">
            <p v-for="(seg, segIndex) in spRefundSegments" :key="segIndex">{{seg.depName }} - {{seg.arrName }}</p>
          </div>
          <div slot="flightNo" slot-scope="spRefundSegments">
            <p v-for="(seg, idx) in spRefundSegments" :key="idx">{{seg.flightNo}}</p>
          </div>
          <div slot="flightDate" slot-scope="spRefundSegments">
            <p v-for="(seg, idx) in spRefundSegments" :key="idx">{{seg.depTime}}</p>
          </div>
          <div slot="createTime" slot-scope="createTime">
            {{ createTime }}
          </div>
          <div slot="refundType" slot-scope="refundType">
            {{ getRefundTypeText(refundType) }}
          </div>
          <div slot="status" slot-scope="status">
            {{ getStatusText(status) }}
          </div>
        </a-table>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import { querySpecialRefundOrderList } from '@/apis/order'
import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import { map } from 'lodash'
import { userTypeMap } from '@/dicts/member'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

// 字典数据
const refundTypeDictData = [
  { value: '', text: '全部' },
  { value: 'EXCHANGE_TICKET', text: '航班改期后退票' },
  { value: 'COMPENSATE', text: '补退差价/手续费' },
  { value: 'USED_TICKET', text: '降舱、备降/经停取消退费' },
  { value: 'DEVIATION_TICKET', text: '偏离退票' },
  { value: 'OPEN_TAX', text: '客票超一年有效期退税' },
  { value: 'DISEASE', text: '病退票' },
  { value: 'OFFLINE_TICKET', text: '离柜退票' },
  { value: 'SPR', text: '高权限客服特殊退票' }
]
const statusDictData = [
  { value: '', text: '全部' },
  { value: 'PENDING', text: '审核中' },
  { value: 'REFUND', text: '已退款' },
  { value: 'FAIL', text: '退款失败' }
]

const orderListCols = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key'
  },
  {
    title: '退单单号',
    dataIndex: 'spRefundNo',
    key: 'spRefundNo'
  },
  {
    title: '航班日期',
    dataIndex: 'spRefundSegments',
    key: 'flightDate',
    scopedSlots: { customRender: 'flightDate' }
  },
  {
    title: '航班号',
    dataIndex: 'spRefundSegments',
    key: 'flightNo',
    scopedSlots: { customRender: 'flightNo' }
  },
  {
    title: '航段',
    dataIndex: 'spRefundSegments',
    key: 'spRefundSegments',
    scopedSlots: { customRender: 'spRefundSegments' }
  },
  {
    title: '申请时间',
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '退票类型',
    dataIndex: 'refundType',
    key: 'refundType',
    scopedSlots: { customRender: 'refundType' }
  },
  {
    title: '退单状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  }
]

export default {
  data () {
    return {
      locale: zhCN,
      fullTabLCol: 9,
      fullTabRCol: 15,
      activeTabKey: '1',
      formLayout: 'inline',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      fullForm: this.$form.createForm(this),
      orderListData: [],
      orderListCols: orderListCols,
      orderPagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        showQuickJumper: true,
        total: 10
      },
      orderLoading: true,
      // 查询参数
      page: 1,
      pageSize: 10,
      startCreateTime: null,
      endCreateTime: null,
      startDepTime: null,
      endDepTime: null,
      depCode: '',
      arrCode: '',
      status: '',
      refundType: '',
      segEndDate: null,
      segStartDate: null,
      userType: '',
      // 字典数据
      refundTypeDictData: refundTypeDictData,
      statusDictData: statusDictData
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        let width = window.innerWidth
        if (width < 992) {
          that.formLayout = 'horizontal'
        } else {
          that.formLayout = 'inline'
        }
      })()
    }
  },
  created () {
    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userType = userTypeMap[userInfo.userType]
    }

    let width = window.innerWidth
    if (width < 992) {
      this.formLayout = 'horizontal'
    }
    this.fetchOrderList()
  },
  computed: {
    queryStartCreateTime () {
      if (this.startCreateTime) {
        return this.startCreateTime.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    queryEndCreateTime () {
      if (this.endCreateTime) {
        return this.endCreateTime.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    queryStartDepTime () {
      if (this.startDepTime) {
        return this.startDepTime.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    queryEndDepTime () {
      if (this.endDepTime) {
        return this.endDepTime.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    queryParams () {
      let params = {
        'startCreateTime': this.queryStartCreateTime,
        'endCreateTime': this.queryEndCreateTime,
        'startDepTime': this.queryStartDepTime,
        'endDepTime': this.queryEndDepTime,
        'page': this.page,
        'size': this.pageSize,
        'depCode': this.depCode || '',
        'arrCode': this.arrCode || '',
        'refundType': this.refundType || ''
      }

      if (this.status === 'PENDING') {
        params.statusList = ['NEW', 'FPASS', 'SPASS', 'BACK', 'REJECT', 'RPENDING']
      } else {
        params.status = this.status || ''
      }

      return params
    }
  },
  methods: {
    startDisabledDate (current) {
      return current && current > moment().endOf('day')
    },
    endDisabledDate (current) {
      if (this.startCreateTime) {
        return current && (current < this.startCreateTime.startOf('day') || current > moment().endOf('day'))
      } else {
        return current && current > moment().endOf('day')
      }
    },
    startSegDisabledDate (current) {
      if (this.segEndDate) {
        return current && (current > this.segEndDate.endOf('day'))
      } else {
        return false
      }
    },
    endSegDisabledDate (current) {
      if (this.segStartDate) {
        return current && (current < this.segStartDate.startOf('day'))
      } else {
        return false
      }
    },
    orderListChangeHandler (pagination) {
      this.page = pagination.current
      this.pageSize = pagination.pageSize

      this.fetchOrderList()
    },
    fullFormSubmitHandler () {
      this.fullForm.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          this.page = 1
          this.fetchOrderList()
        }
      })
    },
    // 查询特殊退票订单列表
    async fetchOrderList () {
      this.orderLoading = true

      try {
        const res = await querySpecialRefundOrderList({
          ...this.queryParams
        })

        this.orderLoading = false

        this.updateOrderList(res.content)
        this.$set(this.orderPagination, 'current', res.number)
        this.$set(this.orderPagination, 'total', res.totalElements)
      } catch (err) {
        this.orderLoading = false

        this.$message.error(err.message || '订单查询失败，请稍后再试')
      }
    },
    updateOrderList (orderList) {
      let orderData = map(orderList, (order, index) => {
        let status = order.status
        if (['NEW', 'FPASS', 'SPASS', 'BACK', 'REJECT', 'RPENDING'].includes(order.status)) {
          status = 'PENDING'
        }
        let item = {
          key: index + 1,
          spRefundNo: order.spRefundNo,
          createTime: order.createTime ? moment(order.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
          status,
          refundType: order.refundType,
          spRefundSegments: order.spRefundSegments || []
        }

        return item
      })

      this.orderListData = orderData
    },
    // 获取退票类型文本
    getRefundTypeText (refundType) {
      const item = this.refundTypeDictData.find(item => item.value === refundType)
      return item ? item.text : refundType
    },
    // 获取退单状态文本
    getStatusText (status) {
      const item = this.statusDictData.find(item => item.value === status)
      return item ? item.text : status
    }
  }
}
</script>

<style lang="less" scoped>
.order-search-container {
  padding: 20px;
}

.ant-btn.order-primary-btn {
  width: 100px;
  height: 42px;
}

/*查询表单样式*/
.order-search-form {
  margin-top: 10px;
  &.ant-form-inline {
    .ant-form-item {
      &.ant-row {
        margin-bottom: 16px;
      }
    }

    .ant-form-item-label label {
      color: #333;
      width: 90px;
      display: inline-block;
    }
  }

  .input-ticket-prefix {
    width: 50px;
  }

  .input-ticket {
    width: 94px;
  }

  .ant-input {
    height: 48px;
  }

  .ant-form-explain {
    margin-top: 0;
  }

  .form-item-ticket {
    .ant-form-explain {
      margin-right: -60px;
    }
  }

  .ant-select,
  .ant-cascader-picker {
    width: 182px;
    display: inline-block;
  }

  .refund-type-select {
    width: 220px !important;
  }

  .ant-select-selection--single {
    height: 48px;
  }

  .ant-select-selection__rendered {
    line-height: 48px;
  }

  .form-split {
    display: inline-block;
    margin-right: 16px;
    line-height: 51.999px;
  }
}

/*订单列表*/
.order-table {
  table {
    td {
      vertical-align: middle;
    }
  }

  .l8-href {
    text-decoration: underline;
  }

  .ant-table-placeholder {
    margin-bottom: 20px;
  }
}
.order-search-table {
  position: relative;

  /*订单列表导出*/
  .order-ext {
    position: absolute;
    bottom: 15px;
    z-index: 1;
  }

  .order-ext-btn {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;

    .l8-icon {
      font-size: 26px;
    }
  }
}

@media only screen and (max-width: 992px) {
  .order-search-form {
    .ant-form-item {
      &.ant-row {
        margin-bottom: 6px;
      }
    }

    .input-ticket-prefix {
      width: 100%;
    }

    .input-ticket {
      width: 100%;
    }

    .ant-form-item-label {
      margin-bottom: 5px;
    }

    .ant-calendar-picker {
      width: 100%;
    }

    .ant-select,
    .ant-cascader-picker {
      width: 100%;
      display: inline-block;
    }

    .form-split {
      display: block;
      line-height: 30px;
    }
  }

  .order-table {
    table {
      td {
        vertical-align: middle;
        min-width: 120px;
      }
    }

    .ant-table {
      overflow-x: scroll;
      word-break: keep-all;
    }
  }

  .ant-btn.order-primary-btn {
    width: 100%;
  }

  .order-ext {
    position: relative;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}

.mod-tip {
  padding: 0 10px;
  font-size: 12px;
  color: #888;

  span {
    margin-left: 5px;
  }
}

@media (min-width: 1200px) and (max-width: 1300px) {
  .order-search-form {
    .form-input-xl-fix {
      .ant-input {
        width: 120px;
      }
    }
  }
}
</style>
